import { TAB_STATES } from '../SidebarV2/constants';
export const isTrashTab = tab => tab === TAB_STATES.TRASH;
export const isUnreadTab = tab => tab === TAB_STATES.UNREAD;
export const isAllTab = tab => tab === TAB_STATES.ALL;